import { render } from "./QuizBg.vue?vue&type=template&id=0c32a096"
import script from "./QuizBg.vue?vue&type=script&lang=js"
export * from "./QuizBg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__